import useAutoCenter from './hooks/internal/useAutoCenter';

var AutoCenter = function AutoCenter() {
  useAutoCenter();
  return false;
};

export default AutoCenter;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9BdXRvQ2VudGVyLmpzIl0sIm5hbWVzIjpbInVzZUF1dG9DZW50ZXIiLCJBdXRvQ2VudGVyIl0sIm1hcHBpbmdzIjoiQUFBQSxPQUFPQSxhQUFQLE1BQTBCLGdDQUExQjs7QUFFQSxJQUFNQyxVQUFVLEdBQUcsU0FBYkEsVUFBYSxHQUFNO0FBQ3ZCRCxFQUFBQSxhQUFhO0FBRWIsU0FBTyxLQUFQO0FBQ0QsQ0FKRDs7QUFNQSxlQUFlQyxVQUFmIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHVzZUF1dG9DZW50ZXIgZnJvbSAnLi9ob29rcy9pbnRlcm5hbC91c2VBdXRvQ2VudGVyJztcblxuY29uc3QgQXV0b0NlbnRlciA9ICgpID0+IHtcbiAgdXNlQXV0b0NlbnRlcigpO1xuXG4gIHJldHVybiBmYWxzZTtcbn07XG5cbmV4cG9ydCBkZWZhdWx0IEF1dG9DZW50ZXI7XG4iXX0=